import axios from 'axios';

const {
    NODE_ENV: env,
    VUE_APP_TEST_USER: id,
    VUE_APP_TEST_MAIL: mail,
    VUE_APP_API_URL: apiUrl,
    VUE_APP_SEARCH_URL: searchUrl
} = process.env;

const additionalHeaders = {
    'Debug-Auth-Id': id,
    'Debug-Auth-Username': mail
};

const instance = axios.create({
    baseURL: apiUrl,
    searchURL: searchUrl,
    headers: env !== 'production' ? additionalHeaders : null
});


export default instance;
